import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateEmployee } from "../redux/slices/employeeReportSlice";
import "../modalstyles/EmployeeEditModal.css";
import { toast } from "react-toastify";

const CustomerEditModal = ({
  isOpen,
  onClose,
  employee,
  onUpdated,
  branches=[],
  roles=[],
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  useEffect(() => {
    if (employee) {
      setFormData({
        fullName: employee.fullName || "",
        email: employee.email || "",
        mobileNumber: employee.mobileNumber || "",
        address: employee.address || "",
        branch: employee.branchName || "",
        role: employee.roleName || "",

        aadhaarNumber: employee.aadhaarNumber || "",
        panNumber: employee.panNumber || "",

        dob: formatDate(employee.dateOfBirth),
        doj: formatDate(employee.dateOfJoining),
      });
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      fullName: formData.fullName,
      email: formData.email,
      mobileNumber: formData.mobileNumber,
      address: formData.address,
      branchName: formData.branch,
      roleName: formData.role,
      aadhaarNumber: formData.aadhaarNumber,
      panNumber: formData.panNumber,
      dateOfBirth: formatDate(formData.dob),
      dateOfJoining: formatDate(formData.doj),
    };

    try {
      console.log("[UPDATE PAYLOAD]", payload);
      await dispatch(updateEmployee({ id: employee.id, payload })).unwrap();
      toast.success("Employee updated successfully");
      onUpdated();
      onClose();
    } catch (error) {
      console.error("[UPDATE ERROR]", error);
      alert("Failed to update employee: " + (error.message || "Unknown error"));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="employeeEditModal-overlay">
      <div className="employeeEditModal-container">
        <h3 className="employeeEditModal-title">Edit Employee</h3>

        <div className="employeeEditModal-form">
          <div className="employeeEditModal-group">
            <label>User Name</label>
            <input
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
            />
          </div>

          <div className="employeeEditModal-group">
            <label>Email</label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="employeeEditModal-group">
            <label>Phone</label>
            <input
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleChange}
            />
          </div>

          <div className="employeeEditModal-group">
            <label>Branch</label>
            <select
              name="branch"
              value={formData.branch || ""}
              onChange={handleChange}
            >
              <option value="">Select Branch</option>
              {branches.map((b) => (
                <option key={b.id} value={b.name}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>

          <div className="employeeEditModal-group">
            <label>Role</label>
           <select name="role" value={formData.role} onChange={handleChange}>
                <option value="">Select Role</option>
                {roles.map((r)=>(
                  <option value={r.name} key={r.id}>{r.name}</option>
                ))}
           </select>
          </div>

          <div className="employeeEditModal-group">
            <label>Aadhaar</label>
            <input
              name="aadhaarNumber"
              value={formData.aadhaarNumber}
              onChange={handleChange}
            />
          </div>

          <div className="employeeEditModal-group">
            <label>Pan</label>
            <input name="panNumber" value={formData.panNumber} onChange={handleChange}/>
          </div>

          <div className="employeeEditModal-group">
            <label>D.O.B</label>
            <input name="dob" value={formData.dob} onChange={handleChange} />
          </div>

          <div className="employeeEditModal-group">
            <label>Joining Date</label>
            <input name="doj" value={formData.doj} onChange={handleChange} />
          </div>

          <div className="employeeEditModal-group employeeEditModal-full">
            <label>Address</label>
            <textarea
              name="address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="employeeEditModal-buttons">
          <button className="employeeEditModal-update" onClick={handleSubmit}>
            Update
          </button>
          <button className="employeeEditModal-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerEditModal;
